export default "__VITE_ASSET__DQJMb02K__"